import type { IntlConfig } from 'react-intl'
import { ReactIntlErrorCode } from 'react-intl'

type IntlOnError = NonNullable<IntlConfig['onError']>

const customIntlOnError: IntlOnError = (err) => {
  if (err.code === ReactIntlErrorCode.MISSING_TRANSLATION) {
    console.warn(`[Intl Error] Missing translation for key: ${err.descriptor?.id}`)
  }
  else if (process.env.NODE_ENV !== 'production') {
    console.error(err)
  }
}

export default customIntlOnError
